import { isMobile } from "components/utility/page-responsive/PageResponsive";
import { useEffect } from "react";
import { showInfographicMobileToLarge } from "utils/ddiff-animations/distance-based-animations/animatedInfoHeadline";
import { getDecodedHtml } from "utils/getDecodedHtml";

type AnimatedExhibitInfographicHeadlineProps = {
	headline: string;
	className?: string;
	microCap?: boolean;
};
const AnimatedExhibitInfographicHeadline = ({
	headline,
	className,
	microCap
}: AnimatedExhibitInfographicHeadlineProps) => {
	useEffect(() => {
		if (isMobile()) {
			showInfographicMobileToLarge();
		}
	}, []);
	return (
		<div className={`ddiff-animated-exhibit-infographic ${className ?? ""}`}>
			<div className="ddiff-animated-exhibit-border">
				<div
					className="ddiff-animated-exhibit-headline t-heading-lg"
					dangerouslySetInnerHTML={{ __html: getDecodedHtml(headline) }}
				/>
			</div>
			{microCap && (
				<div className="ddiff-micro-cap-chart-info">
					<div className="ddiff-micro-cap-chart-title t-label-sm-heavy tc-cool-gray-01">
						The Dimensional Difference Adds Up
					</div>
					<div className="ddiff-micro-cap-chart-growth t-label-xxs">
						Growth of $100,000, 19XX–20XX
					</div>
				</div>
			)}
		</div>
	);
};

export default AnimatedExhibitInfographicHeadline;
